import React from 'react';

import { ComponentStageType } from '../../types';

import { AppHeader } from '../AppHeader';
import { TextTransitionWrapper } from './';
import { ButtonBar } from '../ButtonBar';
import { Button } from '../Button';

import {
    createEnterExitAnimation,
    createFadeInOutAnimation,
} from '../../transitions';
import { animationDelay } from '../../constants';
import { Explanation } from './Steps/Explanation';

interface IProps {
    componentStage: ComponentStageType;
    totalSteps: number;
    onNextButtonClick(): void;
    onCloseButtonClick?(): void;
    onFinalAnimationRest(): void;
}

export const InstructionsView: React.FC<IProps> = ({
    componentStage,
    onNextButtonClick,
    onCloseButtonClick,
    onFinalAnimationRest,
    totalSteps,
}) => {
    const buttonAnimation = createFadeInOutAnimation({
        stage: componentStage,
        delay: animationDelay.second,
        onRest: onFinalAnimationRest,
    });
    const finalAnimation = createEnterExitAnimation({
        stage: componentStage,
    });

    return (
        <>
            <AppHeader
                totalSteps={totalSteps}
                closeButtonOnly
                onCloseButtonClick={onCloseButtonClick}
            />
            <TextTransitionWrapper style={finalAnimation}>
                <Explanation />
            </TextTransitionWrapper>
            <ButtonBar>
                <Button onClick={onNextButtonClick} style={buttonAnimation}>
                    volgende
                </Button>
            </ButtonBar>
        </>
    );
};
